import type { ManifestRouteDefinition } from '@/core/manifest/types'

export const usersRouteRoot: ManifestRouteDefinition = {
  key: 'users',
  path: '/users',
  apiCalls: [
    { url: '/tenants/users?is_active=true', method: 'GET' },
    { url: '/tenants/users?is_active=false', method: 'GET' },
    { url: '/tenants/users/:userId/toggle-active', method: 'PATCH' },
    { url: '/auth/signup', method: 'POST' },
    { url: '/tenants/rbac/roles?is_active=true', method: 'GET' },
    { url: '/tenants/rbac/user-role', method: 'POST' },
  ],
  lazyComponent: () =>
    import('@/features/users/pages/UsersLayout/UsersLayout').then((m) => ({
      default: m.default,
    })),
  indexRedirect: 'active',
  children: [
    {
      key: 'users_active',
      path: 'active',
      apiCalls: [
        { url: '/tenants/users?is_active=true', method: 'GET' },
        { url: '/tenants/users/:userId/toggle-active', method: 'PATCH' },
      ],
      lazyComponent: () =>
        import('@/features/users/pages/UsersActivePage/UsersActivePage').then((m) => ({
          default: m.default,
        })),
    },
    {
      key: 'users_deleted',
      path: 'deleted',
      apiCalls: [
        { url: '/tenants/users?is_active=false', method: 'GET' },
        { url: '/tenants/users/:userId/toggle-active', method: 'PATCH' },
      ],
      lazyComponent: () =>
        import('@/features/users/pages/UsersDeletedPage/UsersDeletedPage').then((m) => ({
          default: m.default,
        })),
    },
    {
      key: 'users_create',
      path: 'create',
      apiCalls: [{ url: '/auth/signup', method: 'POST' }],
      lazyComponent: () =>
        import('@/features/users/pages/CreateUserPage/CreateUserPage').then((m) => ({
          default: m.default,
        })),
    },
    {
      key: 'users_id_shell',
      path: ':id',
      lazyComponent: () =>
        import('@/features/users/pages/UsersIdOutlet/UsersIdOutlet').then((m) => ({
          default: m.default,
        })),
      children: [
        {
          key: 'user_details',
          isIndex: true,
          apiCalls: [
            { url: '/tenants/users?is_active=true', method: 'GET' },
            { url: '/tenants/users?is_active=false', method: 'GET' },
          ],
          lazyComponent: () =>
            import('@/features/users/pages/UserDetails/UserDetails.tsx').then((m) => ({
              default: m.default,
            })),
        },
        {
          key: 'users_map_role',
          path: 'map-role',
          apiCalls: [
            { url: '/tenants/users?is_active=true', method: 'GET' },
            { url: '/tenants/rbac/roles?is_active=true', method: 'GET' },
            { url: '/tenants/rbac/user-role', method: 'POST' },
          ],
          lazyComponent: () =>
            import('@/features/users/pages/MapRolePage/MapRolePage').then((m) => ({
              default: m.default,
            })),
        },
      ],
    },
  ],
}
